import { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ActionCardProps {
  title: string
  description: string
  icon: LucideIcon
  color?: 'blue' | 'teal' | 'purple' | 'amber'
  onClick?: () => void
}

const colorVariants = {
  blue: 'bg-blue-50 text-blue-600 group-hover:bg-blue-100',
  teal: 'bg-teal-50 text-teal-600 group-hover:bg-teal-100',
  purple: 'bg-purple-50 text-purple-600 group-hover:bg-purple-100',
  amber: 'bg-amber-50 text-amber-600 group-hover:bg-amber-100',
}

export function ActionCard({
  title,
  description,
  icon: Icon,
  color = 'teal',
  onClick,
}: ActionCardProps) {
  return (
    <button
      onClick={onClick}
      className="card card-hover group w-full rounded-lg p-4 text-left transition-all duration-200"
    >
      <div className="flex items-center gap-4">
        <div className={cn('rounded-lg p-2.5 transition-colors', colorVariants[color])}>
          <Icon className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <h3 className="font-medium text-gray-900">{title}</h3>
          <p className="text-sm text-gray-500">{description}</p>
        </div>
      </div>
    </button>
  )
}
